export const ADD_CAROUSEL = Symbol('ADD_CAROUSEL');
export const ADD_CAROUSEL_IN_STORE = Symbol('ADD_CAROUSEL_IN_STORE');
export const REQUEST_NEW_VIDEOS = Symbol('REQUEST_NEW_VIDEOS');
export const ADD_NEW_VIDEOS_IN_STORE = Symbol('ADD_NEW_VIDEOS_IN_STORE');

/**
 * @param {number} channelId
 * @param {number} pageNum
 * @param {number} perPage
 * @param {number} position
 * @param {number} numOfVideosToShift
 * @param {number} totalNumberOfVideos
 * @returns {{type: symbol, payload: {channelId: *, pageNum: *, perPage: *, position: *, numOfVideosToShift: *, totalNumberOfVideos: *}}}
 */
export const requestNewVideos = (channelId, pageNum, totalNumberOfVideos) => ({
  type: REQUEST_NEW_VIDEOS,
  payload: {
    channelId,
    pageNum,
    perPage: 12,
    position: 0,
    numOfVideosToShift: 0,
    totalNumberOfVideos,
  },
});

/**
 *
 * @param {number} channelId
 * @param {[]videos} videos
 * @returns {{type: symbol, payload: {channelId: *, videos: *}}}
 */
export const addNewVideosInStore = (channelId, videos) => ({
  type: ADD_NEW_VIDEOS_IN_STORE,
  payload: {
    channelId,
    videos,
  },
});

/**
 *
 * @param {number} channelId
 * @param {number} pageNum
 * @param {number} perPage
 * @param {number} position
 * @returns {{type: symbol, payload: {channelId: *, pageNum: *, perPage: *, position: *}}}
 */
export const addCarousel = (channelId) => ({
  type: ADD_CAROUSEL,
  payload: {
    channelId,
    pageNum: 1,
    perPage: 12,
    position: 0,
  },
});

/**
 *
 * @param {number} channelId
 * @param {number} pageNum
 * @param {number} perPage
 * @param {number} position
 * @param {videos[]} videos
 * @param {number} totalNumberOfVideos
 * @param {boolean} isLoading
 * @returns {{type: symbol, payload: {channelId: *, pageNum: *, perPage: *, videos: *, totalNumberOfVideos: *, position: *}}}
 */
export const addCarouselInStore = (channelId, pageNum, perPage, position, videos, totalNumberOfVideos, isLoading) => ({
  type: ADD_CAROUSEL_IN_STORE,
  payload: {
    channelId,
    pageNum,
    perPage,
    videos,
    totalNumberOfVideos,
    position,
    isLoading,
  },
});
